import { useEffect, useState } from "react";
import { Box, TextField, InputAdornment, IconButton } from "@mui/material";
import { useIntl } from "react-intl";
import useDebounce from "hooks/useDebounce";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

type SearchBoxPersistedProps = {
  persistedSearchTerm: string;
  setPersistedSearchTerm: (searchText: string) => void;
};

const SearchBoxPersisted = ({
  persistedSearchTerm,
  setPersistedSearchTerm,
}: SearchBoxPersistedProps) => {
  const { formatMessage: t } = useIntl();
  const [searchTerm, setSearchTerm] = useState(persistedSearchTerm);
  useEffect(() => {
    setSearchTerm(persistedSearchTerm);
  }, [persistedSearchTerm]);
  const debouncedSearchTerm = useDebounce(searchTerm.trim(), 500);

  useEffect(() => {
    setPersistedSearchTerm(debouncedSearchTerm);
  }, [debouncedSearchTerm, setPersistedSearchTerm]);

  return (
    <Box mb={3}>
      <TextField
        fullWidth
        variant="outlined"
        value={searchTerm ?? ""}
        placeholder={t({ id: "searchPlaceholder" })}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={() => setSearchTerm("")}>
                <ClearIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
        onChange={(e) => {
          setSearchTerm(e.target.value);
        }}
      />
    </Box>
  );
};

export default SearchBoxPersisted;
